import { PieChart } from '@mui/x-charts/PieChart';
import { Box, Typography, IconButton } from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { useApiTrigger } from '../../hooks/useApiTrigger';

const parsePieData = (rawData) => {
    const defaultPalette = [
        '#02B2AF', '#2E96FF', '#B800D8', '#60009B',
        '#2731C8', '#03008D', '#004744', '#00652e'
    ];

    const total = rawData.reduce((acc, curr) => acc + curr.value, 0);

    const dto = rawData.map((item, index) => ({
        id: index,
        value: item.value,
        label: item.category,
        color: item?.color ? item?.color : defaultPalette[index % defaultPalette.length]
    }));

    return { dto, total };
};

const DoughnutChart = ({ data, filters }) => {
    const { dto: dtoChart } = useApiTrigger(data, filters);
    const { dto, total } = parsePieData(dtoChart);

    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                p: 1
            }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                <Typography fontWeight={500} noWrap>
                    {data.accion}
                </Typography>
                {/* <IconButton size="small">
                    <InfoOutlined sx={{ fontSize: 16 }} />
                </IconButton> */}
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexGrow: 1,
                    minHeight: 0,
                }}
            >
                <Box
                    sx={{
                        position: 'relative',
                        height: '100%',
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <PieChart
                        series={[{
                            data: dto,
                            innerRadius: '60%',
                            outerRadius: '95%',
                            paddingAngle: 2,
                            cornerRadius: 4,
                        }]}
                        margin={{ top: 0, bottom: 0, left: 0, right: 0 }}
                        slotProps={{ legend: { hidden: true } }}
                    />

                    <Box
                        sx={{
                            position: 'absolute',
                            textAlign: 'center',
                            pointerEvents: 'none',
                        }}
                    >
                        <Typography variant="h5" fontWeight={600} lineHeight={1}>
                            {total.toLocaleString('es-CO')}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Total
                        </Typography>
                    </Box>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1.5,
                        flex: 1,
                        pl: 2
                    }}
                >
                    {dto.map((item, idx) => (
                        <Box key={idx} display="flex" alignItems="center" justifyContent="space-between">
                            <Box display="flex" alignItems="center" gap={1}>
                                <Box
                                    sx={{
                                        width: 10, height: 10,
                                        borderRadius: '50%',
                                        bgcolor: item.color,
                                    }}
                                />
                                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
                                    {item.label}
                                </Typography>
                            </Box>
                            <Typography variant="caption" fontWeight={600} sx={{ whiteSpace: 'nowrap', ml: 1 }}>
                                {item.value.toLocaleString('es-CO')}
                                <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
                                    ({((item.value / total) * 100).toFixed(1)}%)
                                </Typography>
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
}

export default DoughnutChart;